import { Controller } from "@hotwired/stimulus";
import { put } from "@rails/request.js";

// Stimulus controller for handling item lead time revert
export default class extends Controller {

    revertLeadtime(e) {
        const button = e.currentTarget;

        const url = button.dataset.url;
        const body = {};
        console.log("Reverting lead time via URL:", url);
        put(url, {
            responseKind: 'turbo-stream',
            body: body
        }).then((resp) => {
            if (resp.ok && typeof onSuccess === 'function') onSuccess(resp);
        }).catch((err) => {
            console.error('PUT request failed:', err);
        });
    }

    revertDecorationUpcharge(e) {
        const button = e.currentTarget;
        const url = button.dataset.url;
        const optionId = button.dataset.optionId;
        const body = {
            decoration_id: optionId
        };
        put(url, {
            responseKind: 'turbo-stream',
            body: body
        }).then((resp) => {
            if (resp.ok && typeof onSuccess === 'function') onSuccess(resp);
        }).catch((err) => {
            console.error('PUT request failed:', err);
        });
    }

    revertAsIsPrice(e) {
        const button = e.currentTarget;
        const url = button.dataset.url;
        const body = {};
        console.log("Reverting as-is price via URL:", url);
        put(url, {
            responseKind: 'turbo-stream',
            body: body
        }).then((resp) => {
            if (resp.ok && typeof onSuccess === 'function') onSuccess(resp);
        }).catch((err) => {
            console.error('PUT request failed:', err);
        });
    }

}
